@if (isInitialized && controllers().length > 0) {
  <oe-flat-widget [title]="'EDGE.INDEX.WIDGETS.CHANNELTRESHOLD.TITLE' | translate" button [link]="'/device/' + edge.id + newNavigationUrlSegment + '/history/channelthresholdchart'" [icon]="{ name: 'radio-button-on-outline', color: 'normal', size: 'large' }">
    @for (controller of controllers(); track controller) {
      <oe-flat-widget-line [name]="displayName.get(controller.id)" [channelAddress]="controller.id + '/CumulatedActiveTime'" [converter]="FORMAT_SECONDS_TO_DURATION"></oe-flat-widget-line>
    }
  </oe-flat-widget>
}
